// extracted by mini-css-extract-plugin
export var cardHeader = "_t7-0";
export var reorderHandle = "_t7-3";
export var titleArea = "_t7-1";
export var titleAreaWithHandle = "_t7-2";